import React, { useState, useEffect } from 'react';
import WhiteLogo from '../../assets/digital-porters-logotype-white.svg';
import ColorLogo from '../../assets/digital-porters-logotype-colored.svg';
import { NavLink, useLocation } from 'react-router-dom';
import { useScroll } from '../ScrollContext';
import { styled } from '@mui/material';
import theme from '../../styles';
// import SearchBar from '../SearchBar';

const Navbar = ({ customtextcolor, position, searchBarBackgroundColor }) => {
  const { contact, aboutUs } = useScroll();
  const [scrollPosition, setScrollPosition] = useState(0);
  const location = useLocation();

  const handleScroll = () => {
    setScrollPosition(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (location.hash === '#contacto') {
      scrollToSection(contact);
    }
  }, [location, contact]);

  useEffect(() => {
    if (location.hash === '#about-us') {
      scrollToSection(aboutUs);
    }
  }, [location, aboutUs]);

  const scrollToSection = (sectionRef) => {
    window.scrollTo({
      top: sectionRef.current.offsetTop - 73,
      behavior: 'smooth',
    });
  };

  return (
    <NavbarContainer scrollPosition={scrollPosition} position={position}>
      <LogoContainer>
        <NavLink to='/home'>
          <Logo src={customtextcolor ? ColorLogo : WhiteLogo} alt='Logo de Arcimex' />
        </NavLink>
      </LogoContainer>
      <LinksContainer>
        <NavLinkStyled to='/' end className='nav-link' customtextcolor={customtextcolor}>
          Inicio
        </NavLinkStyled>
        <NavLinkStyled to='/products' className='nav-link' customtextcolor={customtextcolor}>
          Productos
        </NavLinkStyled>
        <NavLinkStyled to='/#contacto' customtextcolor={customtextcolor}>
          Contacto
        </NavLinkStyled>
      </LinksContainer>
    </NavbarContainer >
  );
};

// Styled component using Material-UI's styled function
const NavbarContainer = styled('div')(({ scrollPosition, position }) => ({
  position: position || 'fixed',
  top: 0,
  zIndex: 50,
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxSizing: 'border-box',
  padding: '20px 100px',
  transition: 'background-color 0.3s ease, backdrop-filter 0.3s ease',
  backgroundColor:
    position === 'sticky' ? theme.color.light : scrollPosition !== 0
      ? 'rgba(20, 45, 82, 0.6)'
      : 'transparent',
  backdropFilter: position === 'sticky' || scrollPosition !== 0 ? 'blur(10px)' : 'none',
  boxShadow: position === 'sticky' ? 'none' : scrollPosition !== 0 ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none',

  fontFamily: theme.fontFamily.secondary,
  color: theme.color.light,
  borderBottom: position === 'sticky' ? '1px solid #F2C1A6' : null,
}));

const LogoContainer = styled('div')({
  flexShrink: 0,
  flexBasis: '180px',
});

const Logo = styled('img')({
  width: '200px',
});

const LinksContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '10px',
  flex: 1,
});

const NavLinkStyled = styled(NavLink, {
  shouldForwardProp: (prop) => prop !== 'customtextcolor',
})(({ customtextcolor }) => ({
  color: customtextcolor || theme.color.light,
  textDecoration: 'none',
  fontFamily: theme.fontFamily.secondary,
  fontSize: 16,
  fontWeight: 500,
  letterSpacing: '0.03em',
  padding: '8px 14px',
  borderRadius: 6,
  transition: 'color 0.2s, background-color 0.2s',
  '&:hover': {
    color: theme.color.accent,
  },
  '&.active': {
    color: theme.color.accent,
  },
}));

export default Navbar;
